import { gql } from "@apollo/client";
import GroupRole from "../../services/contants/GroupRole";
export const QUERY_MY_GROUP = gql`
  query Query($group_id: ID!) {
    my_group_membership(group_id: $group_id) {
      id
      role
    }
  }
`;

export const QUERY_GROUP_ATHLETE = gql`
  query Query($group_id: ID!, $athlete_id: ID!) {
    group_athlete(group_id: $group_id, athlete_id: $athlete_id)
  }
`;

export const QUERY_GROUP_MEMBERS = gql`
  query Query($group_id: ID!, $limit: Int, $offset: Int, $filter: JSON) {
    group_members(
      group_id: $group_id
      limit: $limit
      offset: $offset
      filter: $filter
    ) {
      total
      offset
      limit
      filter
      items {
        id
        role
        user {
          id
          firstname
          lastname
          email
        }
      }
    }
  }
`;

export const MUTATION_JOIN_GROUP = gql`
  mutation Mutation($group_id: ID!) {
    join_group(group_id: $group_id) {
      id
    }
  }
`;

export const MUTATION_LEAVE_GROUP = gql`
  mutation Mutation($group_id: ID!) {
    leave_group(group_id: $group_id)
  }
`;

export const MUTATION_ADD_ATHLETE_TO_GROUP = gql`
  mutation Mutation($group_id: ID!, $athlete_id: ID!) {
    add_athlete_to_group(group_id: $group_id, athlete_id: $athlete_id)
  }
`;

export const MUTATION_REMOVE_ATHLETE_FROM_GROUP = gql`
  mutation Mutation($group_id: ID!, $athlete_id: ID!) {
    remove_athlete_from_group(group_id: $group_id, athlete_id: $athlete_id)
  }
`;

export const MUTATION_DELETE_GROUP = gql`
  mutation Mutation($id: ID!) {
    delete_group(id: $id)
  }
`;

export const getGroupQuery = () => {
  return gql`
    query Query($id: ID!) {
      group(id: $id) {
        id
        name

        stats
      }
    }
  `;
};

export const isGroupAdmin = (myGroupMembership) => {
  return [GroupRole.admin, GroupRole.owner].includes(myGroupMembership?.role);
};

export const isGroupOwner = (myGroupMembership) => {
  return myGroupMembership?.role === GroupRole.owner;
};
